"use client";
import React from 'react';
import { motion } from 'framer-motion';

export default function MetaAdsWhatIs() {
    return (
        <section className="relative overflow-hidden py-20 md:py-28 px-6 md:px-16 lg:px-24" style={{ background: '#080400' }}>
            <div className="absolute inset-0 pointer-events-none opacity-[0.03]" style={{ backgroundImage: 'radial-gradient(circle, rgba(206,255,26,1) 1px, transparent 1px)', backgroundSize: '40px 40px' }} />

            <div className="max-w-[900px] mx-auto relative z-10 flex flex-col gap-6">
                <motion.span
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5 }}
                    className="text-xs font-bold tracking-[0.2em] uppercase"
                    style={{ color: '#ceff1a', fontFamily: 'var(--font-clash), "Clash Display", sans-serif' }}
                >
                    The Basics
                </motion.span>

                <motion.h2
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    className="text-3xl md:text-5xl font-bold tracking-tight leading-tight"
                    style={{ fontFamily: 'var(--font-clash), "Clash Display", sans-serif', color: '#fbfdfd' }}
                >
                    What Is Meta Ads Management?
                </motion.h2>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="flex flex-col gap-5"
                >
                    <p
                        className="text-base md:text-lg leading-relaxed"
                        style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}
                    >
                        Meta Ads management involves planning, launching and continuously optimising advertising across platforms such as Facebook and Instagram.
                    </p>
                    <p
                        className="text-base md:text-lg leading-relaxed"
                        style={{ fontFamily: 'var(--font-manrope), Manrope, sans-serif', color: 'rgba(255,255,255,0.6)', letterSpacing: '0.02em' }}
                    >
                        Unlike search advertising, where people often express an existing need, Meta allows brands to create demand, introduce products, build consideration and bring potential customers back into the conversion journey.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
